import "./SideBar.css";
import { NavLink } from "react-router-dom";
import logo from "../../../images/Damas_univ.png";
import { BsFillShieldLockFill } from "react-icons/bs";
import { useContextHook } from "../../../Context/ContextOpen";
import { IconType } from "react-icons";
import Accordion from "../../Accordion/Accordion";
import { fileURL, useFetch } from "../../../ApiS";
import { RiLockPasswordFill } from "react-icons/ri";
import { IoNewspaper } from "react-icons/io5";
import { TbFreezeRowColumn, TbLayoutDashboardFilled } from "react-icons/tb";
import { MdNoAccounts } from "react-icons/md";
import { BiAddToQueue } from "react-icons/bi";
interface images {
  id: number;
  image: string;
}
interface Admin {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  password_confirmation: string;
  old_password: string;
  phone_number: string;
  images: images[];
}

interface ProfileAdmin {
  total: number;
  per_page: number;
  data: Admin;
}

interface SideBarItem {
  name: string;
  link?: string;
  icon: IconType;
  color?: string;
}
interface SidebarTwo {
  name: string;
  link?: string;
  color?: string;
}
interface SidebarStudents {
  name: string;
  link?: string;
  icon?: IconType;
  color?: string;
}
interface SidebarEmp {
  name: string;
  link?: string;
  icon?: IconType;
  color?: string;
}

interface Program {
  name: string;
  link?: string;
  icon?: IconType;
  color?: string;
}

function SideBar() {
  // const { data } = useFetch("admin/profile", "profile" );
  // console.log(data);
  const { openMenu, changeMenu } = useContextHook();
  const month = `${new Date().getFullYear()}-${new Date()
    .getMonth()
    .toString()
    .padStart(2, "0")}-${new Date().getDate().toString().padStart(2, "0")}`;
  const sidebar: SideBarItem[] = [
    // {
    //   name: "الاعلانات",
    //   link: "/ads",
    //   icon: BsFillShieldLockFill,
    // },
    {
      name: "   القوائم الامتحانية  ",
      link: "/exam_lists",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: "لوحة المتابعة",
      link: "/dashboard",
      icon: TbLayoutDashboardFilled,
      color: "MediumSeaGreen",
    },
    {
      name: " الفصول الدراسية الجديدة ",
      link: "/new_semester",
      icon: BiAddToQueue,
      color: "MediumSeaGreen",
    },
    {
      name: "أخبار و إعلانات",
      link: "/news",
      icon: IoNewspaper,
      color: "MediumSeaGreen",
    },

    {
      name: "  تغيير كلمة المرور",
      link: "/change-password",
      icon: RiLockPasswordFill,
      color: "MediumSeaGreen",
    },
    {
      name: "المقررات",
      link: "/curriculums",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: "تجميد الحسابات",
      link: "/freeze_accounts",
      icon: MdNoAccounts,
      color: "yellow",
    },
    {
      name: "تجميد ظهور اي واجهة",
      link: "/freezing_interfaces",
      icon: TbFreezeRowColumn,
      color: "yellow",
    },
    {
      name: "تسليم الوثيقة",
      link: "/document_delivery",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "طباعة الوثيقة",
      link: "/print_document",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "الأحصائيات",
      link: "/statistics",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },

    {
      name: "طلبات النقل",
      link: "/transferreq",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },

    {
      name: "سحب الاسئلة",
      link: "/import_question",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: " فحص تطابق العلامات  ",
      link: "/check_marks_matching",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },

    {
      name: "   استعلام العقوبات الامتحانية  ",
      link: "/exam_penalties_inquiry",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "أصدار قرارات التخرج",
      link: "/graduation_decision",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "القرارات",
      link: "/decisions",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "أرشفة قاعدة البيانات",
      link: "/db_archive",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "ادخال العلامات",
      link: "/enter_results",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
  ];

  const sidebarTwo: SidebarTwo[] = [{ name: "المزيد" }];

  const SidebarStudents: SidebarStudents[] = [{ name: "الطلاب" }];
  const SidebarEmp: SidebarEmp[] = [{ name: "الموظفين" }];
  const Program: Program[] = [{ name: "معلومات البرنامج" }];

  const List = [
    {
      name: "توزيع الطلاب على القاعات الامتحانية",
      link: "/distribution_students",
      color: "yellow",
    },
    {
      name: "فرز أمناء القاعات",
      link: "/sorting_hall_secretaries",
      color: "yellow",
    },
    {
      name: "تفعيل / الغاء تفعيل التفقدات",
      link: "/activate_inspections",
      color: "yellow",
    },
    { name: " استعلام عدد الحضور", link: "/number_attendees", color: "yellow" },
    {
      name: "  استعلام تغيير القاعة",
      link: "/change_hall",
      color: "yellow",
    },
    { name: " لم يسجل مقرر", link: "/no_register_course", color: "yellow" },
    { name: "ضبط الشغب", link: "/riot_control", color: "yellow" },
    { name: " ضبط الغش ", link: "/fraud_control", color: "yellow" },
    { name: "ضبط امتحاني", link: "/examination_report", color: "yellow" },
  ];

  const List_1 = [
    {
      name: "حسابات الطلاب",
      link: "/students",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: "الطلاب الخريجين",
      link: "/graduate_students",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
    {
      name: "الطلاب المستجدين",
      link: "/ٌregesteredstudents",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },

    {
      name: "   الطلاب الاوائل  ",
      link: "/first_students",
      icon: BsFillShieldLockFill,
      color: "yellow",
    },
  ];
  const ProgramList = [
    {
      name: " حول البرنامج ",
      link: "/infomation_application/about",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: " قواعد البرنامج ",
      link: "/infomation_application/program_role",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: " مقررات البرنامج ",
      link: "/infomation_application/subject_program",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
    {
      name: " الكادر التدريسي ",
      link: "/infomation_application/teaching_staff",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
  ];
  const List_2 = [
    {
      name: "حسابات الموظفين",
      link: "/regesteredemployees",
      icon: BsFillShieldLockFill,
      color: "MediumSeaGreen",
    },
  ];

  return (
    <>
      <div
        className={`${
          openMenu
            ? "!w-[360px] max-lg:!w-[250px] max-sm:!w-[250px] "
            : " w-[0px]"
        } ${
          openMenu
            ? "!max-md:translate-x-0 !max-md:w-3/4 -right-0"
            : "!max-md:-translate-x-full"
        }   border-Secondary bg-[#D9D9D9] sidebar h-[100vh] max-md:h-[100%] !z-40 sticky max-md:fixed right-0 top-0 transition-all overflow-y-auto  `}
      >
        <div className="pr-3 py-2 ">
          <ul className="text-black text-center font-semibold space-y-4 ">
            <NavLink to="/">
              {/* <li className="max-md:pt-20">
                <img
                  src={fileURL + data?.data?.images[0]?.image}
                  alt=""
                  className=" w-[100px]  mx-auto bg-white rounded-xl "
                />
                <p className="text-base text-Secondary font-bold">
                  {data?.data?.first_name} {data?.data?.last_name}
                </p>
              </li> */}
            </NavLink>
            {SidebarStudents.map((e, i) => (
              <>
                <li key={i}>
                  {e.name === "الطلاب" ? (
                    <Accordion
                      list={List_1}
                      name="الطلاب"
                      className="bg-[#3cb371]"
                    />
                  ) : (
                    <NavLink
                      to={e.link || ""}
                      className={`flex items-center gap-3 p-[30px] text-sm py-2 rounded-r-full hover:bg-white text-black`}
                      style={{ backgroundColor: e.color }}
                    >
                      {e.name}
                    </NavLink>
                  )}
                </li>
              </>
            ))}
            {SidebarEmp.map((e, i) => (
              <>
                <li key={i}>
                  {e.name === "الموظفين" ? (
                    <Accordion
                      list={List_2}
                      name="الموظفين"
                      className="bg-[#3cb371]"
                    />
                  ) : (
                    <NavLink
                      to={e.link || ""}
                      className="flex items-center gap-3 p-[30px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                      style={{ backgroundColor: e.color }}
                    >
                      {e.name}
                    </NavLink>
                  )}
                </li>
              </>
            ))}
            {Program.map((e, i) => (
              <>
                <li key={i}>
                  {e.name === "معلومات البرنامج" ? (
                    <Accordion
                      list={ProgramList}
                      name="معلومات البرنامج"
                      className="bg-[#3cb371]"
                    />
                  ) : (
                    <NavLink
                      to={e.link || ""}
                      className="flex items-center gap-3 p-[30px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                    >
                      {e.name}
                    </NavLink>
                  )}
                </li>
              </>
            ))}
            {sidebar.map((e, i) => (
              <li key={i}>
                <NavLink
                  style={{ backgroundColor: e.color }}
                  to={e.link || ""}
                  className="flex items-center justify-between gap-3 p-[30px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                >
                  {e.name}
                  <e.icon size={30} />
                </NavLink>
              </li>
            ))}

            {sidebarTwo.map((e, i) => (
              <>
                <li key={i}>
                  {e.name === "المزيد" ? (
                    <Accordion
                      list={List}
                      name="التفقدات"
                      className="bg-[#ffff00]"
                    />
                  ) : (
                    <NavLink
                      to={e.link || ""}
                      className="flex items-center gap-3 p-[30px] text-sm py-2 rounded-r-full hover:bg-white text-black"
                      style={{ backgroundColor: e.color }}
                    >
                      {e.name}
                    </NavLink>
                  )}
                </li>
              </>
            ))}
          </ul>
        </div>
      </div>
      <div
        onClick={changeMenu}
        style={{ transition: "0.4s" }}
        className={`${
          openMenu ? "" : "hidden"
        }  max-md:w-full h-full bg-black/20 fixed -left-0 top-0 transition-all z-[25]`}
      />
    </>
  );
}

export default SideBar;
